var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2501 6.33366H13.4584V4.75033C13.4584 2.56533 11.6851 0.791992 9.50008 0.791992C7.31508 0.791992 5.54175 2.56533 5.54175 4.75033V6.33366H4.75008C3.87925 6.33366 3.16675 7.04616 3.16675 7.91699V15.8337C3.16675 16.7045 3.87925 17.417 4.75008 17.417H14.2501C15.1209 17.417 15.8334 16.7045 15.8334 15.8337V7.91699C15.8334 7.04616 15.1209 6.33366 14.2501 6.33366ZM9.50008 13.4587C8.62925 13.4587 7.91675 12.7462 7.91675 11.8753C7.91675 11.0045 8.62925 10.292 9.50008 10.292C10.3709 10.292 11.0834 11.0045 11.0834 11.8753C11.0834 12.7462 10.3709 13.4587 9.50008 13.4587ZM11.9542 6.33366H7.04591V4.75033C7.04591 3.39658 8.14633 2.29616 9.50008 2.29616C10.8538 2.29616 11.9542 3.39658 11.9542 4.75033V6.33366Z",
    fill: "#255986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.f9aaf507d745c182572694b145c59bea.svg";
export { ForwardRef as ReactComponent };